import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loading from "../../../Loading/Loading";

const PaymentOverviewRow = ({
  course,
  student,
  batch,
  levels,
  onEditClick,
}) => {
  const loadDetails = () => {
    onEditClick(student);
    document.getElementById("my_modal_4").showModal();
  };

  const payments = levels
    .map((level) => {
      const key = `${course}${level}payment`;
      const value = student?.[key];
      return value !== undefined ? { label: `Level ${level}`, value } : null;
    })
    .filter(Boolean);

  if (!student) {
    return <Loading />;
  }

  return (
    <tr className="hover">
      <th>{student?.sn}</th>
      <td>
        {student?.name.toUpperCase()}
        <br />
        <span className="text-sm text-slate-400">
          {student?.fatherName.toUpperCase()}
        </span>
        <br />
        <span className="text-sm text-slate-400">
          <FontAwesomeIcon icon="fa-solid fa-phone" /> {student?.phone}
        </span>
      </td>
      <td>
        {payments.map((item, idx) => (
          <p key={idx}>
            <span className="badge bg-slate-300">{item.label}</span>
            <span
              className={`badge ${
                item.value === "paid"
                  ? "bg-green-400"
                  : item.value === "scholarship"
                  ? "bg-cyan-400"
                  : "bg-orange-400"
              }`}
            >
              {item.value}
            </span>
          </p>
        ))}
      </td>
      <td>
        <span
          onClick={loadDetails}
          className="cursor-pointer badge bg-slate-300 px-5 py-3"
        >
          Edit
        </span>
      </td>
    </tr>
  );
};

export default PaymentOverviewRow;
